import { Tag, Text } from '@nimbus-ds/components';
import { CouponStatus } from '@tiendanube/common';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import Skeleton from './Skeleton';

const APPEARENCE: Record<
  CouponStatus | 'expired',
  'success' | 'neutral' | 'warning'
> = {
  enabled: 'success',
  disabled: 'neutral',
  forbidden: 'warning',
  expired: 'warning',
};

interface StatusProps {
  status: CouponStatus;
  isExpired?: boolean;
}

/**
 * Determines the status key for display based on expiration state
 * Priority: expired status overrides actual status
 *
 * @param status - The current coupon status from backend
 * @param isExpired - Whether the coupon has expired by date
 * @returns The status key to use for display and styling
 */
function getStatusKey(
  status: CouponStatus,
  isExpired: boolean,
): CouponStatus | 'expired' {
  if (isExpired) {
    return 'expired';
  }

  return status;
}

export function Status({ status, isExpired = false }: Readonly<StatusProps>) {
  const t = useTranslationMarketing();

  const displayStatus = getStatusKey(status, isExpired);

  return (
    <Tag appearance={APPEARENCE[displayStatus]}>
      <Text fontSize="caption" lineClamp={1}>
        {t(`coupons.details.status.${displayStatus}`)}
      </Text>
    </Tag>
  );
}

Status.Skeleton = Skeleton;
